

export const FEATURESHIGHLIGHTS = [
    {
    id: 'widget',
    icon: '../assets/icon/add.webp',
    title: 'Resmi Yazışma Altyapısı',
    desc: 'E-imza, EYP ve entegre KEP altyapısı ile resmi yazışma süreçlerini dijital yönetin.',
    bg: 'linear-gradient(145deg, #fffbf5 0%, #fff7ed 100%)',
    borderColor: 'rgba(252, 141, 5, 0.36)',
    accentColor: '#fc8d05',
  },
  {
    id: 'flexible',
    icon: '/assets/icon/flexibility.webp',
    title: 'Esnek Sistem',
    desc: 'Her dernek için ihtiyaca göre şekillenen modüler yapı.',
    bg: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)',
    borderColor: 'rgba(3,192,255,0.15)',
    accentColor: '#03c0ff',
  },
    {
    id: 'transparent',
    icon: '/assets/icon/transparency.webp',
    title: 'Şeffaf Yönetim',
    desc: 'Üye, aidat ve bağış süreçlerini şeffaf ve izlenebilir şekilde yönetin.',
    bg: 'linear-gradient(145deg, #ffffff 0%, #fefcf8 100%)',
    borderColor: 'rgba(252,141,5,0.1)',
    accentColor: '#fc8d05',
  },
  {
    id: 'secure',
    icon: '/assets/icon/lock.webp',
    title: 'Güvenli Altyapı',
    desc: 'KVKK uyumlu ve bulut tabanlı güvenli veri altyapısı.',
    bg: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
    borderColor: 'rgba(3,192,255,0.12)',
    accentColor: '#0187b3',
  },
  {
    id: 'fast',
    icon: '/assets/icon/material.webp',
    title: 'Hızlı Kurulum',
    desc: 'Dakikalar içinde kurulum yapın ve hemen kullanmaya başlayın.',
    bg: 'linear-gradient(145deg, #ffffff 0%, #f0fafe 100%)',
    borderColor: 'rgba(3,192,255,0.1)',
    accentColor: '#03c0ff',
  },
];